import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Detail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getRolePrivileges } from 'src/app/privileges/privileges.selector';
import { ExtensionGroupOption } from '../../extension-groups-register/models/extension-group-option.interface';
import { ExtensionOption } from '../../extension-register/models/extension-option.interface';
import { RolePrivileges } from '../../role-register/models/role-privileges';
import { RoleDetailSaveEvent } from '../models/role-detail-form-submit-event';
import { PrivilegeView, RoleDetailView } from '../models/role-detail-view.model';
import { RoleDetailFormService } from '../services/role-detail-form.service';
import * as RoleDetailActions from '../state/role-detail.actions';
import {
   getPrivileges,
   getRoleCallState,
   getRoleDetail,
   getRoleDetailExtensionGroups,
   getRoleDetailExtensions,
} from '../state/role-detail.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: { class: 'entity-detail' },
    providers: [RoleDetailFormService, { provide: FormsBase, useExisting: RoleDetailFormService }],
    selector: 'ndt-role-detail',
    templateUrl: './role-detail.component.html',
    standalone: false
})
export class RoleDetailComponent extends Detail<RoleDetailFormService> implements OnInit {
   role$: Observable<RoleDetailView | null>;

   rolePrivileges$: Observable<RolePrivileges>;

   privileges$: Observable<PrivilegeView[] | null>;

   extensions$: Observable<ExtensionOption[]>;

   extensionGroups$: Observable<ExtensionGroupOption[]>;

   constructor(public store: Store, private router: Router, protected formService: RoleDetailFormService) {
      super(store, formService);
   }

   ngOnInit(): void {
      this.role$ = this.store.pipe(select(getRoleDetail));
      this.rolePrivileges$ = this.store.pipe(select(getRolePrivileges));
      this.privileges$ = this.store.pipe(select(getPrivileges));
      this.callState$ = this.store.pipe(select(getRoleCallState));
      this.extensions$ = this.store.pipe(select(getRoleDetailExtensions));
      this.extensionGroups$ = this.store.pipe(select(getRoleDetailExtensionGroups));

      this.store.dispatch(RoleDetailActions.roleDetailLoad());
      this.store.dispatch(RoleDetailActions.privilegesLoad());

      this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((e) => {
         if (e instanceof NavigationEnd) {
            this.store.dispatch(RoleDetailActions.roleDetailLoad());
         }
      });
   }

   onFormSaveCanceled(): void {
      this.store.dispatch(RoleDetailActions.roleDetailCancel());
   }

   onFormSubmitted(event: RoleDetailSaveEvent) {
      this.store.dispatch(RoleDetailActions.saveRoleDetail(event));
   }

   onDeleteRole(event: { roleId: number; name: string }) {
      this.store.dispatch(RoleDetailActions.deleteRole(event));
   }
}
